'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('ErrorResponseHandler', function() {
  var ErrorResponseHandler = function() {
    this.errorHandlers = {
      '4xx': 'error.server.unhandled',
      '5xx': 'error.server.not.available'
    };
  };

  ErrorResponseHandler.prototype.withCustom4xxErrorMessage = function(errorString) {
    this.errorHandlers['4xx'] = errorString;
    return this;
  };

  ErrorResponseHandler.prototype.withCustom5xxErrorMessage = function(errorString) {
    this.errorHandlers['5xx'] = errorString;
    return this;
  };

  ErrorResponseHandler.prototype.registerErrorMessages = function(errorMessageObj) {
    angular.forEach(errorMessageObj, function(value, key) {
      this.errorHandlers[key] = value;
    }, this);
    return this;
  };

  ErrorResponseHandler.prototype.parseErrorResponse = function(response) {
    var errorHandler = this.errorHandlers[response.status];
    var responseType = response.status.toString().substr(0, 1);
    var defaultHandler = this.errorHandlers[responseType + 'xx'];

    if (!errorHandler) {
      if (!defaultHandler) {
        return;
      }
      errorHandler = defaultHandler;
    }

    if (typeof errorHandler === 'string') {
      return errorHandler;
    } else {
      var reasonHandler = errorHandler[response.data.reason];
      if (!reasonHandler) {
        return defaultHandler;
      }
      return reasonHandler;
    }
  };

  return ErrorResponseHandler;
});
